import React from 'react';
import styled from 'styled-components';
import PostRichContent from './PostRichContent';
import type { OriginalPostSnapshot } from '../../utils/postEdit';

type OriginalPostDialogProps = {
  snapshot: OriginalPostSnapshot | null;
  onClose: () => void;
};

const Scrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  place-items: center;
  padding: 1.25rem;
  background: rgba(15, 23, 42, 0.55);
`;

const Card = styled.div`
  width: min(640px, 100%);
  max-height: min(80vh, 760px);
  overflow: auto;
  border-radius: 16px;
  background: var(--surface, #fff);
  color: var(--on-surface, #111);
  padding: 1.25rem;
`;

const Title = styled.h2`
  margin: 0 0 0.85rem;
  font-size: 1.15rem;
`;

const CloseButton = styled.button`
  margin-top: 1rem;
`;

export default function OriginalPostDialog({ snapshot, onClose }: OriginalPostDialogProps) {
  if (!snapshot) return null;

  return (
    <Scrim role="presentation" onClick={onClose}>
      <Card
        role="dialog"
        aria-modal="true"
        aria-label="Original post"
        onClick={(event) => event.stopPropagation()}
      >
        <Title>Original post</Title>
        <PostRichContent
          text={snapshot.content || 'This version had no text.'}
          images={snapshot.images}
          videoUrl={snapshot.videoUrl ?? undefined}
          imageAlt="Original post"
        />
        <CloseButton type="button" onClick={onClose}>
          Close
        </CloseButton>
      </Card>
    </Scrim>
  );
}
